module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "booksection"
  }, [_c('h1', [_c('b', [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "start2"
  }), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "#/cap01"
    }
  }, [_c('b', [_vm._v("TOOLS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t1"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("1")])]), _vm._v("   Use the 15 Greatest Lures of All Time")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t2"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("2")])]), _vm._v("   Meet 15 New Classics")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t3"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("3")])]), _vm._v("   Make Over Lures with Toothpaste")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t4"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("4")])]), _vm._v("   Do DIY Custom Lure Colors")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t5"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("5")])]), _vm._v("   Secure Your Lure")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t6"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("6")])]), _vm._v("   Tune a Crankbait")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t7"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("7")])]), _vm._v("   Keep Lures from Hanging Up")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t8"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("8")])]), _vm._v("   Build a Budget Lure")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t9"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("9")])]), _vm._v("   Make Your Own Trout Spinners")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t10"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("10")])]), _vm._v("   Catch Big Bass with Bunny Fur")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t11"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("11")])]), _vm._v("   Rig Me Softly")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t12"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("12")])]), _vm._v("   Make Spooks Spookier")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t13"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("13")])]), _vm._v("   Use an Irresistible Jig")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t14"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("14")])]), _vm._v("   Soft-Sell a Muskie")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t15"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("15")])]), _vm._v("   Give New Life to Old Bass Lures")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t16"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("16")])]), _vm._v("   Fish the Top 10 Freshwater Baits")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t17"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("17")])]), _vm._v("   Harvest Nature’s Bait Bounty")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t18"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("18")])]), _vm._v("   Buzz a Worm")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t19"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("19")])]), _vm._v("   Become a Worm Farmer")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t20"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("20")])]), _vm._v("   Let Some Livies Loose")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t21"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("21")])]), _vm._v("   Score Minnows with Bubble Gum")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t22"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("22")])]), _vm._v("   Throw Chum a Long Way")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t23"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("23")])]), _vm._v("   Catch Big Fish with Big Lures")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t24"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("24")])]), _vm._v("   Make Your Own Catfish Candy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t25"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("25")])]), _vm._v("   Go Dark and Deep")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t26"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("26")])]), _vm._v("   Make a Double-Sided Worm Can")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t27"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("27")])]), _vm._v("   Sweep for ’Eyes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t28"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("28")])]), _vm._v("   Pick the Best Reel for the Job")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t29"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("29")])]), _vm._v("   Get Some Guidance")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t30"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("30")])]), _vm._v("   Fish to Live")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t31"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("31")])]), _vm._v("   Perform Emergency Guide Repairs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t32"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("32")])]), _vm._v("   Let the Rod Do the Work")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t33"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("33")])]), _vm._v("   Have a Cane-Do Attitude")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t34"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("34")])]), _vm._v(" "), _c('b', [_vm._v("KNOW YOUR:")]), _vm._v(" Bluegill")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t35"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("35")])]), _vm._v("   Put on the Brakes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t36"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("36")])]), _vm._v("   Unravel Backlashed Line")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t37"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("37")])]), _vm._v("   Feather a Spinning Reel 50 Feet")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t38"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("38")])]), _vm._v("   Overhaul Your Reel in 15 Minutes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t39"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("39")])]), _vm._v("   Choose the Right Line")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t40"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("40")])]), _vm._v("   Lead the Way")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t41"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("41")])]), _vm._v("   Match Your Fluorocarbon to Your Fish")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t42"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("42")])]), _vm._v("   Tie a Palomar Knot")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t43"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("43")])]), _vm._v("   Get into Heavy Metal")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t44"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("44")])]), _vm._v("   Change Hooks for Better Fishing")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t45"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("45")])]), _vm._v("   Shake Your Head")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t46"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("46")])]), _vm._v("   Adjust Your Bobber to the Fish")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t47"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("47")])]), _vm._v("   Play the Baiting Game")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t48"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("48")])]), _vm._v("   Gain Some Weight")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t49"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("49")])]), _vm._v("   Tie a Clinch Knot")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t50"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("50")])]), _vm._v("   Make It Snappy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t51"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("51")])]), _vm._v("   Properly Sharpen a Fishhook")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t52"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("52")])]), _vm._v("   Rig a Slip Bobber")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t53"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("53")])]), _vm._v("   Use the Best Trout Fly for the Job")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t54"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("54")])]), _vm._v("   Tie a Five-Minute Fly")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t55"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("55")])]), _vm._v("   Make a Seine")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t56"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("56")])]), _vm._v("   Know Your Bugs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t57"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("57")])]), _vm._v("   Make the Most of a Springtime Pond")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t58"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("58")])]), _vm._v("   Practice Animal Magnetism")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t59"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("59")])]), _vm._v("   Jig Your Buck")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t60"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("60")])]), _vm._v("   Catch a Trout’s Attention")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t61"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("61")])]), _vm._v("   Tie a Clouser Minnow")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t62"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("62")])]), _vm._v("   Make Flies, Not Bugs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t63"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("63")])]), _vm._v("   Join the Bass Bug Revolution")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t64"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("64")])]), _vm._v("   Experience Fatal Attraction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t65"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("65")])]), _vm._v("   Get the Inside Scoop on Fly Reels")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t66"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("66")])]), _vm._v("   Understand Your Fly Reel")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t67"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("67")])]), _vm._v("   Get in Line")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t68"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("68")])]), _vm._v("   Buck the Wind")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t69"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("69")])]), _vm._v("   Master Shorter Casts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t70"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("70")])]), _vm._v("   Cast About")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t71"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("71")])]), _vm._v("   Lose the Tailing Loop")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t72"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("72")])]), _vm._v("   Control Your Wrist")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t73"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("73")])]), _vm._v("   Point Your Shots")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t74"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("74")])]), _vm._v("   Keep Flies in Mint Condition")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t75"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("75")])]), _vm._v("   Fish the Cycle")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t76"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("76")])]), _vm._v("   Make a Beer-Box Stripping Basket")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t77"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("77")])]), _vm._v("   Accessorize Your Tackle Box")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t78"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("78")])]), _vm._v("   Make an Essential Repair Kit")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t79"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("79")])]), _vm._v("   Make the Ultimate Ice-Fishing Bucket")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t80"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("80")])]), _vm._v("   Pick the Most Important Tool")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t81"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("81")])]), _vm._v("   Hit the Ice Two Ways")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t82"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("82")])]), _vm._v(" "), _c('b', [_vm._v("KNOW YOUR:")]), _vm._v(" Northern Pike")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t83"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("83")])]), _vm._v("   Mind Your Monitor")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t84"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("84")])]), _vm._v("   Get Better Sonar Reception")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t85"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("85")])]), _vm._v("   Pick a Rod with Reach")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t86"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("86")])]), _vm._v("   Drift On")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t87"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("87")])]), _vm._v(" "), _c('b', [_vm._v("KNOW YOUR:")]), _vm._v(" Blue Catfish")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t88"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("88")])]), _vm._v("   Grub a Spinner")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t89"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("89")])]), _vm._v("   Net a Hellgrammite")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t90"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("90")])]), _vm._v("   Wade after Your Bass")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t91"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("91")])]), _vm._v("   Drift a Hellgrammite")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t92"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("92")])]), _vm._v("   Release Your Anchor Quickly")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t93"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("93")])]), _vm._v(" "), _c('b', [_vm._v("KNOW YOUR:")]), _vm._v(" Rainbow Trout")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t94"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("94")])]), _vm._v("   Cast from a Kayak")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t95"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("95")])]), _vm._v("   Tie a Trucker’s Hitch Knot")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t96"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("96")])]), _vm._v("   Avoid River Obstacles")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t97"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("97")])]), _vm._v("   Pack and Paddle for Power")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t98"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("98")])]), _vm._v("   Tie a Canoe to Your Racks")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t99"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("99")])]), _vm._v("   Get Up the Creek")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t100"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("100")])]), _vm._v("   Be Sneaky")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t101"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("101")])]), _vm._v("   Go, Speed Racer (Safely)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t102"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("102")])]), _vm._v("   Keep Your Footing")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t103"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("103")])]), _vm._v("   Diagnose and Cure a Sick Motor")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t104"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("104")])]), _vm._v("   Avoid Fouled Outboards")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t105"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("105")])]), _vm._v("   Save Gas")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t106"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("106")])]), _vm._v("   Back Your Trailer Easily")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t107"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("107")])]), _vm._v("   Protect Your Trailer Lights")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t108"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("108")])]), _vm._v(" "), _c('b', [_vm._v("KNOW YOUR:")]), _vm._v(" Steelhead")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t109"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("109")])]), _vm._v("   Fight Corrosion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t110"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("110")])]), _vm._v("   Give ’Em the Slip Bobber")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t111"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("111")])]), _vm._v("   Belly Up to a Bass")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t112"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("112")])]), _vm._v("   Drag a Worm")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#t113"
    }
  }, [_c('span', {
    staticClass: "col1"
  }, [_c('b', [_vm._v("113")])]), _vm._v("   Have a G’Day, Mate")])]), _vm._v(" "), _c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p5.jpg"
    }
  })]), _vm._v(" "), _c('h2', [_c('span', {
    attrs: {
      "href": "#/cap02",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("TECHNIQUES")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t114",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("114")])]), _vm._v("   Crank Up Your Spring")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t115",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("115")])]), _vm._v("   Build a Better Tube Rig")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t116",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("116")])]), _vm._v("   Catch Bass without a Boat")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t117",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("117")])]), _vm._v("   Stock Up on Essentials")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t118",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("118")])]), _vm._v("   Get the Bass Bugs Out")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t119",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("119")])]), _vm._v("   Dredge a Bronzeback")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t120",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("120")])]), _vm._v("   Tune Up for Shallow Bass")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t121",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("121")])]), _vm._v("   Wake ’Em Up")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t122",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("122")])]), _vm._v("   Get More Out of Your Frog")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t123",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("123")])]), _vm._v("   Do the Double Dog")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t124",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("124")])]), _vm._v("   Strike in the Night")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t125",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("125")])]), _vm._v("   Make the Perfect Pitch")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t126",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("126")])]), _vm._v("   Hunt Down Largemouths in Falling Waters")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t127",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("127")])]), _vm._v("   Work a Worm in Reverse")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t128",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("128")])]), _vm._v("   Catch Bass in the Cold")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t129",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("129")])]), _vm._v("   Do Some Heavy Lifting")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t130",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("130")])]), _vm._v(" "), _c('b', [_vm._v("KNOW YOUR:")]), _vm._v(" Largemouth Bass")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t131",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("131")])]), _vm._v("   Shrink Your Jig")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t132",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("132")])]), _vm._v("   Buzz a Grub")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t133",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("133")])]), _vm._v("   Fine-Tune a Carolina Rig")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t134",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("134")])]), _vm._v("   Put a Different Spin on It")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t135",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("135")])]), _vm._v("   Thaw Out a Trout")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t136",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("136")])]), _vm._v("   Beat a Cutbank Goliath")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t137",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("137")])]), _vm._v("   Spot and Stalk Trout")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t138",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("138")])]), _vm._v("   Use Copper to Go Deep")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t139",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("139")])]), _vm._v("   Perfect the Parachute Cast")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t140",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("140")])]), _vm._v("   Master the Mend")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t141",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("141")])]), _vm._v("   Shoot the Breeze")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t142",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("142")])]), _vm._v("   Drift a Wet Fly with a Dry Leaf")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t143",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("143")])]), _vm._v("   Fly in the Cold")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t144",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("144")])]), _vm._v("   Dredge a Fall Steelie")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t145",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("145")])]), _vm._v("   Multi-Crank for Crappies")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t146",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("146")])]), _vm._v("   Follow the Crappie Highways")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t147",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("147")])]), _vm._v("   Slide a Grub")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t148",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("148")])]), _vm._v("   Get into the Grass")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t149",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("149")])]), _vm._v("   Catch Crappies under a Bridge")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t150",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("150")])]), _vm._v("   Dangle a Bunch of Livies")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t151",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("151")])]), _vm._v("   Catch Your Biggest Bluegill of the Year")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t152",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("152")])]), _vm._v("   Drop in on Spring ’Gills")])]), _vm._v(" "), _c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p6.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t153",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("153")])]), _vm._v("   Tag-Team Winter Perch")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t154",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("154")])]), _vm._v("   Take a Shot in the Dock")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t155",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("155")])]), _vm._v("   Get Post-Ice Air")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t156",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("156")])]), _vm._v("   Go Long, Wide, and Deep for Walleyes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t157",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("157")])]), _vm._v("   Fish a Weed-Cutter Rig")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t158",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("158")])]), _vm._v("   Hook Walleyes in the Hot Months")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t159",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("159")])]), _vm._v("   Weed Out Trophy Walleyes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t160",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("160")])]), _vm._v("   Follow the Foliage")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t161",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("161")])]), _vm._v(" "), _c('b', [_vm._v("KNOW YOUR:")]), _vm._v(" Walleye")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t162",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("162")])]), _vm._v("   Fish the Walleye Weather Report")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t163",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("163")])]), _vm._v("   Test Your Deep-Water Skills")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t164",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("164")])]), _vm._v("   Use a Slow Death Rig")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t165",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("165")])]), _vm._v("   Do a Fall Minnow Double-Take")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t166",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("166")])]), _vm._v("   Go Slow and Steady to Win a Walleye")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t167",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("167")])]), _vm._v("   Land a Pike or Muskie from Your Kayak")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t168",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("168")])]), _vm._v("   Pack the Pliers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t169",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("169")])]), _vm._v("   Hook a Hard-to-Catch Trophy Pike")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t170",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("170")])]), _vm._v("   Rig It Right for Picky Pike")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t171",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("171")])]), _vm._v("   Lure a Big, Bad Pike")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t172",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("172")])]), _vm._v("   Read a Pike Bay")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t173",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("173")])]), _vm._v(" "), _c('b', [_vm._v("KNOW YOUR:")]), _vm._v(" Chain Pickerel")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t174",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("174")])]), _vm._v("   Go Shallow for Postspawn Muskies")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t175",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("175")])]), _vm._v("   Strike Quick to Get That Muskie")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t176",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("176")])]), _vm._v("   Dog a Muskie")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t177",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("177")])]), _vm._v("   Get Lucky with a Ducky")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t178",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("178")])]), _vm._v("   Mesmerize a Muskie with a Figure 8")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t179",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("179")])]), _vm._v("   Make an L-Turn")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t180",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("180")])]), _vm._v("   Flip a Muskie the Bird")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t181",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("181")])]), _vm._v(" "), _c('b', [_vm._v("KNOW YOUR:")]), _vm._v(" Muskellunge")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t182",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("182")])]), _vm._v("   Feed the Kitty")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t183",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("183")])]), _vm._v("   Use the Right Cat Rig")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t184",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("184")])]), _vm._v("   Use Your Noodle")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t185",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("185")])]), _vm._v("   Watch the Spines")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t186",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("186")])]), _vm._v("   Catch a Big Cat from a Small Boat")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t187",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("187")])]), _vm._v("   Get the Blues in a River")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t188",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("188")])]), _vm._v("   Go Bullish on Bullheads")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t189",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("189")])]), _vm._v("   Catch a Reservoir Cat")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t190",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("190")])]), _vm._v("   Go Bobbing for Cats")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t191",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("191")])]), _vm._v("   Skin a Cat")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t192",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("192")])]), _vm._v("   Tackle Carp on the Fly")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t193",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("193")])]), _vm._v("   Find Them Where They Feed")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t194",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("194")])]), _vm._v("   Sight-Cast to Suckermouths")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t195",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("195")])]), _vm._v("   Shoot a Carp in the Air")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t196",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("196")])]), _vm._v("   Dance with a Spey Rod")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t197",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("197")])]), _vm._v("   Add Flavor to Your Salmon Lure")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t198",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("198")])]), _vm._v("   Pick a Pickerel Fight")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t199",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("199")])]), _vm._v("   Score a Midsummer Striper")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t200",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("200")])]), _vm._v("   Give a Dam")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t201",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("201")])]), _vm._v("   Pull Big Live Baits")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t202",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("202")])]), _vm._v("   Work the Inshore Hit List")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t203",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("203")])]), _vm._v("   Dance the Jig")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t204",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("204")])]), _vm._v("   Bob an Eel")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t205",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("205")])]), _vm._v("   Rig an Eel for Stripers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t206",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("206")])]), _vm._v("   Get Loaded for Stripers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t207",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("207")])]), _vm._v("   Go from Pond to Bayou")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t208",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("208")])]), _vm._v("   Lose the Spin")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t209",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("209")])]), _vm._v("   Box in a Red")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t210",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("210")])]), _vm._v("   Call in a Monster Shark with D Batteries")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t211",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("211")])]), _vm._v("   Whip a Japanese Jig")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t212",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("212")])]), _vm._v("   Get the Gaff!")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t213",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("213")])]), _vm._v("   Vibe Out Your Live Bait")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t214",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("214")])]), _vm._v("   Work a Pencil Popper")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t215",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("215")])]), _vm._v("   Nail a Weakfish")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t216",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("216")])]), _vm._v("   Snap Some Rubber")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t217",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("217")])]), _vm._v("   Sting a Flattie")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap02#t218",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col2"
  }, [_c('b', [_vm._v("218")])]), _vm._v(" "), _c('b', [_vm._v("KNOW YOUR:")]), _vm._v(" Striped Bass")])]), _vm._v(" "), _c('h2', [_c('span', {
    attrs: {
      "href": "#/cap03",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("TACTICS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t219",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("219")])]), _vm._v("   Beat the Weeds for Fall Trout")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t220",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("220")])]), _vm._v("   Find a Secret Fishing Spot")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t221",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("221")])]), _vm._v(" "), _c('b', [_vm._v("KNOW YOUR:")]), _vm._v(" Crappie")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t222",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("222")])]), _vm._v("   Sneak Up on More Fish")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t223",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("223")])]), _vm._v("   Hold Your Breath")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t224",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("224")])]), _vm._v("   Release Fish Unharmed")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t225",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("225")])]), _vm._v("   Avoid Double-Haul Mistakes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t226",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("226")])]), _vm._v("   Unstick Yourself")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t227",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("227")])]), _vm._v("   Get Upstream")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t228",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("228")])]), _vm._v(" "), _c('b', [_vm._v("KNOW YOUR:")]), _vm._v(" Cutthroat Trout")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t229",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("229")])]), _vm._v("   Master 8 Minnow Tricks for Trout")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t230",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("230")])]), _vm._v("   Stay with Your Trout River this Fall")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t231",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("231")])]), _vm._v("   Play to a Surface-Feeding Trout")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t232",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("232")])]), _vm._v(" "), _c('b', [_vm._v("KNOW YOUR:")]), _vm._v(" Brown Trout")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t233",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("233")])]), _vm._v("   Swim a Spring")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t234",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("234")])]), _vm._v("   Fish Headwaters for Autumn Trout")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t235",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("235")])]), _vm._v("   Drop Right In")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t236",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("236")])]), _vm._v("   Cut Some Slack")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t237",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("237")])]), _vm._v("   Fish with Your Eyes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t238",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("238")])]), _vm._v("   Hook More Rising Fish")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t239",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("239")])]), _vm._v("   Lift and Lower")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t240",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("240")])]), _vm._v("   Do It Right on the River")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t241",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("241")])]), _vm._v("   Paddle Troll")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t242",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("242")])]), _vm._v("   Execute a Power Pivot")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t243",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("243")])]), _vm._v("   Ride the Current in a Canoe")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t244",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("244")])]), _vm._v("   Drift and Dredge")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t245",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("245")])]), _vm._v(" "), _c('b', [_vm._v("KNOW YOUR:")]), _vm._v(" Flathead Catfish")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t246",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("246")])]), _vm._v("   Snag the Best Casting Position")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t247",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("247")])]), _vm._v("   Catch Smallmouths with the Bait That Bites Back")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t248",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("248")])]), _vm._v("   Get the Drop on Bass")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t249",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("249")])]), _vm._v(" "), _c('b', [_vm._v("KNOW YOUR:")]), _vm._v(" Smallmouth Bass")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t250",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("250")])]), _vm._v("   Pull Bass from Beneath the Boards")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t251",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("251")])]), _vm._v("   Shake the Bed for Giant Bass")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t252",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("252")])]), _vm._v("   Send Jerkbaits Down Deep")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t253",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("253")])]), _vm._v("   Send Frogs Undercover")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t254",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("254")])]), _vm._v("   Rip a Rattlebait")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t255",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("255")])]), _vm._v("   Jig a Worm")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t256",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("256")])]), _vm._v("   Use Monster Tubes in the Shallows")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t257",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("257")])]), _vm._v("   Catch Fish in the Prop Wash")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t258",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("258")])]), _vm._v("   Learn to Swim")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t259",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("259")])]), _vm._v("   Skip a Jig in Tight Quarters")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t260",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("260")])]), _vm._v("   Keep on the Grass")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t261",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("261")])]), _vm._v("   Take It to the Slopes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t262",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("262")])]), _vm._v("   Cast the Cranks of Spring")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t263",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("263")])]), _vm._v("   Catch a Big, Fat Perch")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t264",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("264")])]), _vm._v("   Knock on Wood")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t265",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("265")])]), _vm._v("   Throw a One-Two Bass Punch")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t266",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("266")])]), _vm._v("   Enjoy a Carolina Egg Roll")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t267",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("267")])]), _vm._v(" "), _c('b', [_vm._v("KNOW YOUR:")]), _vm._v(" Yellow Perch")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t268",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("268")])]), _vm._v("   Learn Deep Secrets")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t269",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("269")])]), _vm._v("   Get the Lead Out for Walleyes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t270",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("270")])]), _vm._v("   Take the Long Shot")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t271",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("271")])]), _vm._v("   Go on the Offshore Offensive")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t272",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("272")])]), _vm._v("   Catch Walleyes 6 Ways")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t273",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("273")])]), _vm._v("   Find Late-Summer Largemouths")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t274",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("274")])]), _vm._v("   Get a Jumbo on the Rocks")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t275",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("275")])]), _vm._v("   Get a Big Yellow")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t276",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("276")])]), _vm._v("   Have a Big Bass After-Party")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t277",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("277")])]), _vm._v("   Catch Nighttime Smallmouths")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t278",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("278")])]), _vm._v("   Find Trout in the Dark")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t279",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("279")])]), _vm._v("   Flatline for Crappies")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t280",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("280")])]), _vm._v(" "), _c('b', [_vm._v("KNOW YOUR:")]), _vm._v(" Carp")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t281",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("281")])]), _vm._v("   Slow Down for Nighttime Muskies")])]), _vm._v(" "), _c('p', {
    staticClass: "start1"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p9.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t282",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("282")])]), _vm._v("   See a Cat in the Dark")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t283",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("283")])]), _vm._v("   Adjust the Contrast")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t284",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("284")])]), _vm._v("   Troll with Downriggers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t285",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("285")])]), _vm._v("   Get a Walleye on Board")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t286",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("286")])]), _vm._v("   Grab a Cold One")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t287",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("287")])]), _vm._v("   Go Spinnerbaiting for Coldwater Bass")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t288",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("288")])]), _vm._v(" "), _c('b', [_vm._v("KNOW YOUR:")]), _vm._v(" Brook Trout")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t289",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("289")])]), _vm._v("   Crank Pockets for Prespawn Bass")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t290",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("290")])]), _vm._v("   Crank the Creek")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t291",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("291")])]), _vm._v("   Take Swimming Lessons")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t292",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("292")])]), _vm._v("   Cherry-Pick the Trees")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t293",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("293")])]), _vm._v("   Beat the Draw-Down")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t294",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("294")])]), _vm._v("   Reign in the Rain")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t295",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("295")])]), _vm._v("   Cover the Cover")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t296",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("296")])]), _vm._v("   Go Slingin’ in the Rain")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t297",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("297")])]), _vm._v("   Give in to Blind Ambition")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t298",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("298")])]), _vm._v("   Know When You’re on Thin Ice")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t299",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("299")])]), _vm._v("   Jig Big Lakers in Skinny Water")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t300",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("300")])]), _vm._v("   Drill Down on It")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t301",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("301")])]), _vm._v("   Be a Walleye Puppet Master")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t302",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("302")])]), _vm._v("   Catch a Shad-Mad Cat")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t303",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("303")])]), _vm._v("   Hit the Farm Ice")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t304",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("304")])]), _vm._v("   Power Up")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t305",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("305")])]), _vm._v(" "), _c('b', [_vm._v("KNOW YOUR:")]), _vm._v(" Chinook Salmon")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t306",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("306")])]), _vm._v("   Catch Cold Steel")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t307",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("307")])]), _vm._v("   Assume the Tuna Position")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t308",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("308")])]), _vm._v("   Get a Jump on Stealthy Snook")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t309",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("309")])]), _vm._v(" "), _c('b', [_vm._v("KNOW YOUR:")]), _vm._v(" Red Drum")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t310",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("310")])]), _vm._v("   Get the Red Out")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t311",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("311")])]), _vm._v("   Ditch the Wire")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t312",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("312")])]), _vm._v("   Take ’Em to School")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t313",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("313")])]), _vm._v("   Pop on Over")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t314",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("314")])]), _vm._v("   Find Stripers in the Dark")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t315",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("315")])]), _vm._v("   Mount Your Catch and Eat It, Too")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t316",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("316")])]), _vm._v("   Scale Fish with Water")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#t317",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "col3"
  }, [_c('b', [_vm._v("317")])]), _vm._v("   Print That Fish")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("         Glossary")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("         Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d3bbc574","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toc.vue
// module id = 63
// module chunks = 0